import { useCallback, useEffect, useState } from 'react';
import { getDepositoTabelaPrecos } from '@spark/services/deposito';
import { notification } from '@spark/ui-components/utils/notification';
import { toApiDate } from '@spark/utils/formatters';

const normalizeFilters = (filtros) => (
  Object.fromEntries(
    Object.entries(filtros)
      .filter(([key, value]) => value !== undefined && value !== null && value !== '' && !(key === 'SemCliente' && value === false))
      .map(([key, value]) => [key, value instanceof Date ? toApiDate(value) : value])
  )
);

export const useDepositoTabelaPrecoSelection = (show) => {
  const [tabelas, setTabelas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtros, setFiltros] = useState({});
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [quantidadePorPagina, setQuantidadePorPagina] = useState(10);
  const [totalRegistros, setTotalRegistros] = useState(0);

  const carregarTabelas = useCallback(async () => {
    try {
      setLoading(true);
      const params = {
        PaginaAtual: paginaAtual,
        QuantidadePorPagina: quantidadePorPagina,
        ...normalizeFilters(filtros)
      };

      const response = await getDepositoTabelaPrecos(params);
      const data = response?.data || response || {};
      const registros = Array.isArray(data.registros) ? data.registros : [];

      setTabelas(registros);
      setTotalRegistros(data.totalRegistros || registros.length);
    } catch (error) {
      console.error('Erro ao carregar tabelas de preco:', error);
      notification.error(
        error?.message || 'Nao foi possivel carregar as tabelas de preco',
        'Erro ao carregar tabelas de preco'
      );
      setTabelas([]);
      setTotalRegistros(0);
    } finally {
      setLoading(false);
    }
  }, [filtros, paginaAtual, quantidadePorPagina]);

  useEffect(() => {
    if (show) {
      carregarTabelas();
    }
  }, [show, carregarTabelas]);

  const handleFiltrosChange = useCallback((novosFiltros) => {
    setFiltros(novosFiltros);
    setPaginaAtual(1);
  }, []);

  const handlePaginationChange = useCallback((paginationState) => {
    if (paginationState.pageSize !== quantidadePorPagina) {
      setQuantidadePorPagina(paginationState.pageSize);
      setPaginaAtual(1);
    } else if (paginationState.pageIndex !== undefined) {
      setPaginaAtual(paginationState.pageIndex + 1);
    }
  }, [quantidadePorPagina]);

  const resetFiltros = useCallback(() => {
    setFiltros({});
    setPaginaAtual(1);
    setQuantidadePorPagina(10);
  }, []);

  const reload = useCallback(() => {
    carregarTabelas();
  }, [carregarTabelas]);

  return {
    tabelas,
    loading,
    filtros,
    paginaAtual,
    quantidadePorPagina,
    totalRegistros,
    handleFiltrosChange,
    handlePaginationChange,
    resetFiltros,
    reload
  };
};
